import groq from "groq";

export const TRUSTED_HOME_PAGE_QUERY = groq`
*[_type == "trusted-home-care-page"][0]{
  _type,
  _id,
  _createdAt,
  _updatedAt,
  _rev,
  title,
  subtitle,
  description,
  consultationSectionTitle,
  consultationSectionSubtitle,
  consultationSectionSubtitleBlocks,
  consultationButtonText,
  benefitsSectionTitle,
  benefitsSectionSubtitle,
  benefitsList[]{ 
    _key,
    title,
    content,
    icon { 
      asset->{ 
        _id,
        url,
        metadata { 
            dimensions
        }
      }
    }
  },
  testimonialsSectionTitle,
  testimonialsList[0...3]{ 
    _key,
    name,
    text
  }
}
`;
